import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  selectAnatomy.keys
);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  field: {
    marginBottom: '0px',
    borderRadius: '8px',
    fontSize: 'lg',
    paddingLeft: 4,
    paddingRight: 16,
    backgroundColor: 'white'
  },
  icon: {
    //color: 'blue.400',
    boxSize: '48px',
    fontSize: '3xl'
  }
});

export const selectTheme = defineMultiStyleConfig({
  defaultProps: {
    size: 'xl'
  },
  baseStyle
});
